/**
 * Per-club logo paths in Supabase Storage (ClubLogo bucket).
 * Each club stores: `{clubID}/ClubLogo.png`
 */

export function normalizeClubLogoId(clubID) {
  if (clubID == null || clubID === "") return null;
  return String(clubID);
}

/** Public URL for a club's logo in Supabase Storage. */
export function getClubLogoPublicUrl(clubID, { refreshKey = 0 } = {}) {
  const id = normalizeClubLogoId(clubID);
  if (!id) return null;

  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const clubLogoPath = process.env.REACT_APP_SUPABASE_CLUB_LOGO_URL;
  if (!supabaseUrl || !clubLogoPath) return null;

  const cacheBust = `${refreshKey}-${Math.random().toString(36).slice(2, 9)}`;
  return `${supabaseUrl}${clubLogoPath}${id}/ClubLogo.png?t=${cacheBust}`;
}

/** Storage path inside the ClubLogo bucket (no leading slash). */
export function getClubLogoStoragePath(clubID) {
  const id = normalizeClubLogoId(clubID);
  if (!id) return null;
  return `${id}/ClubLogo.png`;
}
